export const convertTooltipPanelToCalloutStyle = () => ({
  '.bingads-webui-react-callout-popover .popover-content': {
    '& .panel': {
      border: 'none',
      boxShadow: 'none',
      marginBottom: 0,
    },
    '& .panel-heading, & .panel-header': {
      padding: '18px 0 12px 0',
      '& .panel-title': {
        fontSize: 20,
        lineHeight: '28px',
        fontWeight: 600,
      },
    },
    '& .panel-title': {
      marginTop: 0,
    },
    '& .panel-body': {
      padding: 0,
    },
    '& .panel-footer': {
      padding: 0,
      border: 'none',
    },
  },
});
